var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC192CA4-B536-44D2-A452-A3531384FE76@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Ongoing-casting",
    transform: "translate(-209.000000, -421.000000)",
    fill: "#F22B5D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.068712,421.361829 C230.504294,421.055666 229.855215,421.055666 229.319018,421.389662 L225.622086,423.532803 L225.622086,423.115308 C225.622086,421.946322 224.662577,421 223.477018,421 L211.144785,421 C209.959509,421 209,421.946322 209,423.115308 L209,432.884692 C209,434.053678 209.959509,435 211.144785,435 L223.505521,435 C224.690798,435 225.650307,434.053678 225.650307,432.884692 L225.650307,432.383698 L229.37546,434.526839 C229.657669,434.693837 229.967816,434.777336 230.250025,434.777336 C230.560736,434.777336 230.842945,434.693837 231.125153,434.554672 C231.689571,434.248509 232,433.691849 232,433.05169 L231.971779,422.864811 C231.971779,422.252485 231.633129,421.695825 231.068712,421.361829 L231.068712,421.361829 Z",
    id: "Fill-1-Copy-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFilled);
export default __webpack_public_path__ + "static/media/cameraFilled.e58fd20e12663b9657864262beeaa992.svg";
export { ForwardRef as ReactComponent };